import { IconProps } from './types';

export const IconSend = ({ size = 16, color = 'currentColor', ...props }: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 16 16' fill='none' {...props}>
    <path
      d='M6.33993 2.82009L12.0466 5.67342C14.6066 6.95342 14.6066 9.04676 12.0466 10.3268L6.33993 13.1801C2.49993 15.1001 0.933265 13.5268 2.85327 9.69342L3.43326 8.54009C3.57993 8.24676 3.57993 7.76009 3.43326 7.46676L2.85327 6.30676C0.933265 2.47342 2.5066 0.90009 6.33993 2.82009Z'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M3.62671 8H7.22671' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

export default IconSend;
